import { useAppSelector } from '../../data/store';
import { SortEnum } from './sort-enum';
import { getIsChina } from '../../../../domain/hidden-data-provider';

/**
 * get sort options
 */
export const getSortOptions = (showPriceSorting: boolean) => {

    const isChina = getIsChina();

    const options = [
        {
            key: SortEnum.Trending,
            value: SortEnum.Trending,
            text: 'Trending',
        },
    ];

    if(showPriceSorting){
        options.push({
            key: SortEnum.PriceAsc,
            value: SortEnum.PriceAsc,
            text: 'Price: Low to High',
        });

        options.push({
            key: SortEnum.PriceDesc,
            value: SortEnum.PriceDesc,
            text: 'Price: High to Low',
        });
    }

    if(!isChina){
        options.push({
            key: SortEnum.MostReviewed,
            value: SortEnum.MostReviewed,
            text: 'Most Reviewed',
        });
    }

    options.push( {
        key: SortEnum.NameAsc,
        value: SortEnum.NameAsc,
        text: 'Product Name: A-Z',
    });

    options.push({
        key: SortEnum.NameDesc,
        value: SortEnum.NameDesc,
        text: 'Product Name: Z-A',
    });

    return options;
};

/**
 * get value based on state parameters
 */
export const useGetValue = () => {
    const sortType = useAppSelector(store => store.sortType);
    const sortProperty = useAppSelector(store => store.sortProperty);
    const sortOrder = useAppSelector(store => store.sortOrder);

    let value = SortEnum.Trending;

    if(sortType === 'text' && sortProperty === 'documentName'){
        value = sortOrder === 'asc' ? SortEnum.NameAsc : SortEnum.NameDesc;
    }

    if(sortType === 'number'){

        if(sortProperty === 'skuPrice'){
            value = sortOrder === 'asc' ? SortEnum.PriceAsc : SortEnum.PriceDesc;
        }

        if(sortProperty === 'reviewsTotal'){
            value = SortEnum.MostReviewed;
        }
    }

    return value;
};